import Icon from '../components/Icon.vue'

Icon.register({
  warehouse: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M504 352c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-367.7c-4.4 0-8-3.6-8-8l0.1-48c0-4.4 3.6-8 8-8h367.6zM504 448c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-368c-4.4 0-8-3.6-8-8l0.1-48c0-4.4 3.6-8 8-8h367.9zM504 256c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-367.5c-4.4 0-8-3.6-8-8l0.1-48c0-4.4 3.6-8 8-8h367.4zM610.5 117c17.8 7.5 29.5 24.9 29.5 44.3v342.7c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-248c0-17.6-14.6-32-32.6-32h-382.8c-18 0-32.6 14.4-32.6 32v248c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-342.7c0-19.4 11.7-36.8 29.5-44.3l272-113.3c4.9-2 13.2-3.7 18.5-3.7 5.3 0 13.6 1.6 18.5 3.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/warehouse.js
// module id = 2103
// module chunks = 0